import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material";
import { ExcelService, Combo2Service, ComboService } from "../../../services/index";
import { SalesOrderService } from "../../../services/salesOrder.service";
import { FormControl } from "@angular/forms";
import * as _ from "lodash";

@Component({
  selector: "new-pending-order",
  templateUrl: "newPendingOrder.html",
})
export class newPendingOrder implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  seasonList = [];
  finyearList = [];
  seasonfinList = [];
  isLoadMask: Promise<any>;
  loadingIndicator: boolean;
  gridOptions: any;
  IsWait: boolean = false;
  exceldata: any;
  curDate = new Date();
  newViewType = ["ORDER","NON ORDER"];
  newViewDesign = ["ALL COLOR","SINGLE COLOR"];
  printConfig : any = {
    title : '',
    columns : [],
    rows : []
  }
  filter = {
    from_date: "",
    to_date: "",
    newDesignShade: "",
    new_view_design: "",
    shade: "",
    groupby: "design",
    new_view_type: "ORDER",
  };
  columns = [];
  excelColumns = [];
  toggleCol = [];
  newDesignList = [];

  pendingOrderStock: any;
  stockOrder: any;
  totalOrderPend: any;

  constructor(
    private salesOrderServ: SalesOrderService,
    private spin: MatProgressSpinnerModule,
    private excelService: ExcelService,
    private combo: Combo2Service,
    public datePipe: DatePipe,
    public comboservice: ComboService

  ) {
    let from_date =
        this.curDate.getFullYear() +
        "-" +
        this.curDate.getMonth() +
        "-" +
        this.curDate.getDate(),
      to_date =
        this.curDate.getFullYear() +
        "-" +
        (this.curDate.getMonth() + 1) +
        "-" +
        this.curDate.getDate();

    this.filter.from_date = this.datePipe.transform(from_date, "yyyy-MM-dd");
    this.filter.to_date = this.datePipe.transform(to_date, "yyyy-MM-dd");
    this.loadingIndicator = true;
  }

  ngOnInit(): void {
    // this.finyearCombo();
    // this.getSeasonList();
    this.getNewDesignList();  
    this.getColumns();  

    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };

    this.toggleCol = Object.assign({}, this.columns);
  }

  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

  }
  pageCallback() {
    this.getNewPendingOrder();
  }

  onPrevClick() {
    if (this.filter.groupby == "designColor") {
      this.filter.groupby = "design";
      this.filter.newDesignShade = "";
      this.filter.new_view_design = "";
    }
    // if (this.filter.groupby == "designColorOrder") {
    //   this.filter.groupby = "designColor";
    //   this.filter.newDesignShade = this.pendingOrderStock[0].design_no;
    //   this.filter.shade = "";
    // }

    this.getNewPendingOrder();
  }

  getNewDesignList() {
    let params = {
      newViewType: this.filter.new_view_type,
    };
    this.salesOrderServ.getNewDesignList(params).then((res: any) => {
      this.newDesignList = res;
    });
   }
   onSelectNewPend(viewtype) {
    this.filter.new_view_type =viewtype;
    this.getNewDesignList();
  }
  onSelectNewDesign(viewDesign:any) {
    this.filter.new_view_design =viewDesign;
    // this.getNewDesignList();
  }
  // finyearCombo() {
  //   let that = this;
  //   this.combo.finyearCombo().then((res: any) => {
  //     that.finyearList = res.data;
  //     that.filter.fin_id = res.data[0].fin_id;
  //     that.finyearCtrl.setValue(res.data[0].fin_id);
  //     that.onSelectFinyear(res.data[0].fin_id);
  //     that.getSeasonList();
  //   });
  // }
  // getSeasonList() {
  //   let params = {
  //     date: new Date().getFullYear(),
  //     page: 1,
  //     start: 0,
  //     limit: 100,
  //   };
  //   this.comboservice.getBrandNewSeason(params).then((res: any) => {
  //     this.seasonList = res;
  //     let today = new Date();
  //     let dd = String(today.getDate()).padStart(2, '0');
  //     let mm = String(today.getMonth() + 1).padStart(2, '0');
  //     let yyyy = today.getFullYear();

  //     let checkDate = yyyy + '-' + mm + '-' + dd;
  //     let curSeason = res.filter(el => checkDate >= el.order_from && checkDate <= el.order_to );
  //     this.allseason();
  //     if(curSeason.length > 0){
  //       this.seasonCtrl.setValue(curSeason[0].season_id);
  //     }else{
  //       this.seasonCtrl.setValue(res[res["length"] - 1].season_id);
  //     }
      
  //     this.getNewPendingOrder();
  //   });
  // }
  // allseason() {
  //   let fin_id = parseInt(this.filter.fin_id);

  //   this.seasonList.forEach(() => {
  //     let seasonAll = {
  //       season: "ALL",
  //       season_id: this.seasonList[this.seasonList["length"] - 1].season_id + 1,
  //       fin_id: fin_id,
  //     };
  //     if (fin_id > 0) {
  //       this.seasonList.push(seasonAll);
  //     }
  //     fin_id = fin_id - 1;
  //   });
  // }
  // onSelectFinyear(id) {
  //   this.filter.season_id = "";
  //   var fin_id = id;
  //   // let seasonfinList = _.filter(this.seasonList, fin_id );
  //   let seasonfinList = this.seasonList.filter((res) => res.fin_id == fin_id);
  //   this.seasonfinList = seasonfinList;
  //   this.seasonCtrl.setValue(
  //     this.seasonfinList[this.seasonfinList["length"] - 1].season_id
  //   );
  //   this.filter.season_id = this.seasonfinList[
  //     this.seasonfinList["length"] - 1
  //   ].season_id;
  //   this.filter.season = this.seasonfinList[
  //     this.seasonfinList["length"] - 1
  //   ].season;
  // }
  // displayFinyear(comboType: string, id: number) {
  //   let list: any = [];
  //   if (comboType == "Finyear") {
  //     list = this.finyearList;
  //   }
  //   if (id && list.length > 0) {
  //     let fitem = _.find(list, { fin_id: id });
  //     return fitem["finyear"];
  //   }
  //   return "";
  // }

  // displayFn(comboType: string, id: number) {
  //   let list: any = [];
  //   let that = this;
  //   list = that.seasonList;

  //   if (id && list.length > 0) {
  //     let fitem = _.find(list, { season_id: id });
  //     return fitem["season"];
  //   }
  //   return "";
  // }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }
  getNewPendingOrder() {
    this.IsWait = true;

    if (this.filter.newDesignShade == "") {
      this.filter.groupby = "design";
    }
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    let params = {
      filter: JSON.stringify(this.filter),
    };

    let that = this;

    that.gridOptions = {
      loading: true,
      columns: [],
    };
    that.salesOrderServ.getNewPendingOrder(params).then((res: any) => {
      this.IsWait = false;
      that.pendingOrderStock = res.pendOrdStock;
      if (that.filter.new_view_type == "ORDER") {
        that.pendingOrderStock = that.pendingOrderStock.filter((stkArr) => stkArr.tot > 0);
      }
      if (that.filter.groupby == "designColor") {
        that.pendingOrderStock.forEach((e, ind) => {
          if (ind != that.pendingOrderStock.length - 1) {
            if ((that.pendingOrderStock[ind].design_id == that.pendingOrderStock[ind + 1].design_id)) {
              that.pendingOrderStock[ind].stot = 0;
            }
          }

        });

      }

      that.setColumns(that.filter.groupby);

      if (that.filter.groupby == "designColor") {
        that.pendingOrderStock = that.pendingOrderStock.sort(
          (a, b) => parseFloat(a.shade) - parseFloat(b.shade)
        );
      }
      // if (that.filter.groupby == "designColorOrder") {
      //   that.stockOrder = res.stockArr;
      //   that.totalOrderPend = res.totalOrderPend;
      // }
      that.printConfig = {
        title: "New Pending Ord.Qty Vs Stock",
        columns: that.excelColumns,
        rows: that.pendingOrderStock,
      };
      that.exceldata = that.getData(that.excelColumns, that.pendingOrderStock);
    });
  }
  setColumns(groupby) {
    if (groupby == "design") {
      this.excelColumns = [
        {
          name: "sno",
          prop: "sno",
        },
        {
          name: "Design No",
          prop: "design_no",
        },
        {
          name : "No.Colors",
          prop : "clrs"
        },
        {
          name: "Pend.Ftot",
          prop: "ftot",
        },
        {
          name: "Pend.Htot",
          prop: "htot",
        },
        {
          name: "Pend.Tot",
          prop: "tot",
        },
         {
          name : "",
          prop : "",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
         },

        {
          name: "Stock.Ftot",
          prop: "sftot",
        },
        {
          name: "Stock.Htot",
          prop: "shtot",
        },
        {
          name: "Stock.Tot",
          prop: "stot",
        },
      ];
    } else if (groupby == "designColor") {
      this.excelColumns = [
        {
          name: "sno",
          prop: "sno",
        },
        {
          name: "So.No",
          prop: "so_no",
        },
        {
          name: "So.Date",
          prop: "so_date",
        },
        {
          name: "Party Name",
          prop: "party_name",
        },
        {
          name: "Design No",
          prop: "design_no",
        },
        {
          name: "Shade",
          prop: "shade",
        },
        {
          name: "F36",
          prop: "f36",
        },
        {
          name: "F38",
          prop: "f38",
        },
        {
          name: "F40",
          prop: "f40",
        },
        {
          name: "F42",
          prop: "f42",
        },
        {
          name: "F44",
          prop: "f44",
        },
        {
          name: "F46",
          prop: "f46",
        },
        {
          name: "H36",
          prop: "h36",
        },
        {
          name: "H38",
          prop: "h38",
        },
        {
          name: "H40",
          prop: "h40",
        },
        {
          name: "H42",
          prop: "h42",
        },
        {
          name: "H44",
          prop: "h44",
        },
        {
          name: "H46",
          prop: "h46",
        },
        {
          name: "F.TOT",
          prop: "ftot",
        },
        {
          name: "H.TOT",
          prop: "htot",
        },
        {
          name: "TOT",
          prop: "tot",
        },
      ];
    } 
    // else if (groupby == "designColorOrder") {
    //   this.excelColumns = [
    //     {
    //       name: "sno",
    //       prop: "sno",
    //     },
    //     {
    //       name: "So.No",
    //       prop: "so_no",
    //     },
    //     {
    //       name: "So.Date",
    //       prop: "so_date",
    //     },
    //     {
    //       name: "Party Name",
    //       prop: "party_name",
    //     },
    //     {
    //       name: "F36",
    //       prop: "f36",
    //     },
    //     {
    //       name: "F38",
    //       prop: "f38",
    //     },
    //     {
    //       name: "F40",
    //       prop: "f40",
    //     },
    //     {
    //       name: "F42",
    //       prop: "f42",
    //     },
    //     {
    //       name: "F44",
    //       prop: "f44",
    //     },
    //     {
    //       name: "F46",
    //       prop: "f46",
    //     },
    //     {
    //       name: "H36",
    //       prop: "h36",
    //     },
    //     {
    //       name: "H38",
    //       prop: "h38",
    //     },
    //     {
    //       name: "H40",
    //       prop: "h40",
    //     },
    //     {
    //       name: "H42",
    //       prop: "h42",
    //     },
    //     {
    //       name: "H44",
    //       prop: "h44",
    //     },
    //     {
    //       name: "H46",
    //       prop: "h46",
    //     },
    //     {
    //       name: "F.TOT",
    //       prop: "ftot",
    //     },
    //     {
    //       name: "H.TOT",
    //       prop: "htot",
    //     },
    //     {
    //       name: "TOT",
    //       prop: "tot",
    //     },
    //   ];
    // }
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }
  onDesignClick(stock) {
    if (this.filter.groupby == "design") {
      this.filter.groupby = "designColor";
      this.filter.newDesignShade = stock.design_no;
    } else if (this.filter.groupby == "designColor") {
      // this.filter.groupby = "designColorOrder";
      this.filter.newDesignShade = stock.design_no;
      this.filter.shade = stock.shade;
    }

    this.getNewPendingOrder();
  }

  ngOnDestroy() {
    this.salesOrderServ;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/salesReports/newPendingOrder/newPendingOrder.ts